<script>
    export let text = '';

    // Mirrors GuideText.WithGamePrefixes: "wlf" is a game id prefix, always lowercase
    // and always monospaced, wherever it appears in curated content.
    $: parts = String(text).split(/\b(wlf)\b/i);
</script>

{#each parts as part, index}
    {#if index % 2 === 1}
        <code class="game-prefix">wlf</code>
    {:else}
        {part}
    {/if}
{/each}
